import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductMonitor14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M7 8C7.55228 8 8 7.55228 8 7C8 6.44772 7.55228 6 7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.48275 6.44427C4.33395 5.38502 5.57196 4.25 7 4.25C8.42803 4.25 9.66606 5.38501 10.5173 6.44427C10.9638 7 10.5922 7.46034 10.5972 7.45373C9.75594 8.56187 8.45324 9.75 7 9.75C5.57196 9.75 4.33395 8.61498 3.48275 7.55573C3.21292 7.21992 3.20714 6.78727 3.48275 6.44427ZM9.01361 7C8.50373 7.545 7.78912 8.25 7 8.25C6.21088 8.25 5.49628 7.545 4.98639 7C5.49628 6.455 6.21088 5.75 7 5.75C7.78912 5.75 8.50373 6.455 9.01361 7ZM10.5972 7.45373C10.5922 7.46034 10.5989 7.46034 10.5972 7.45373V7.45373Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 1.25C10.1756 1.25 12.75 3.82436 12.75 7C12.75 8.31746 12.3069 9.53143 11.5616 10.501L13.5303 12.4697L12.4696 13.5303L10.501 11.5617C9.53138 12.3069 8.31743 12.75 7 12.75C3.82436 12.75 1.25 10.1756 1.25 7C1.25 3.82436 3.82436 1.25 7 1.25ZM11.25 7C11.25 4.65279 9.34721 2.75 7 2.75C4.65279 2.75 2.75 4.65279 2.75 7C2.75 9.34721 4.65279 11.25 7 11.25C9.34721 11.25 11.25 9.34721 11.25 7Z'
      fill='currentColor'
    />
  </Svg>
);

ProductMonitor14.displayName = 'ProductMonitor14';
export default ProductMonitor14;
